// Modules
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import "dayjs/locale/ca";
import "dayjs/locale/es";
import "dayjs/locale/pt";

// Settings
import { LANGUAGE_KEY } from "./settings";
import "./utils";
import "./components/toasts";
import "./components/datepicker";
import "./components/dropdown";
import "./components/input";
import "./components/loader";
import "./components/modal";

// Helpers
import { getSession } from "./helpers";
import { initLastOffersViewedComp } from "./components/lastOffersViewed";

dayjs.extend(relativeTime);

$(() => {
  const isSessionUp = getSession() != null;
  if (!isSessionUp) {
    localStorage.clear();
  }

  dayjs.locale(LANGUAGE_KEY);

  $("#languageSelect").on("click", (ev) => event?.preventDefault());

  initLastOffersViewedComp();
});
